import { render, staticRenderFns } from "./UnidentifiedChats.vue?vue&type=template&id=46fb1aad&lang=pug&"
import script from "./UnidentifiedChats.vue?vue&type=script&lang=js&"
export * from "./UnidentifiedChats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports